import { RadioGroupField } from 'lib/iterable-hook-form';
import { ChartDisplay } from 'modules/messagingInsights/types';
import { Orientation } from 'ui/radioGroup/types';
import { TimeSeriesRadioGroupContainer } from './Styled';

type Props = {
  fieldName: string;
};

export const TimeSeriesFormField = ({ fieldName }: Props) => {
  return (
    <TimeSeriesRadioGroupContainer data-test="time-series-settings">
      <RadioGroupField
        name={fieldName}
        orientation={Orientation.HORIZONTAL}
        options={[
          { id: ChartDisplay.ONE, value: ChartDisplay.ONE, label: '1 chart / page' },
          { id: ChartDisplay.FOUR, value: ChartDisplay.FOUR, label: '4 charts / page' },
        ]}
      />
    </TimeSeriesRadioGroupContainer>
  );
};
